import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { globalModel } from "./global/GlobalModel";
import { ProfileCompleteModal } from "./profile/ProfileCompleteModal";
import { GlobalLoginModal } from "./global/GlobalLoginModal";
import { RelatedSpacesOrdersModalsProvider } from "./platform_spaces/shell/RelatedSpacesOrdersModalsProvider";
import { IS_STANDALONE } from "./standalone/config";
import { StandaloneFooter } from "./standalone/footer/StandaloneFooter";
import { SiteFooter } from "./platform_spaces/shell/SiteFooter";
import { PageLayoutProvider, usePageLayoutContext } from "./layout/PageLayoutContext";
import "./AppLayout.css";

function AppLayoutBody() {
  const { hideFooter } = usePageLayoutContext();

  const layout = (
    <div
      className={`app-layout${hideFooter ? " app-layout--no-footer" : ""}`}
    >
      <div className="app-layout-main">
        <Outlet />
      </div>
      <ProfileCompleteModal />
      <GlobalLoginModal />
      {!hideFooter ? (IS_STANDALONE ? <StandaloneFooter /> : <SiteFooter />) : null}
    </div>
  );

  if (IS_STANDALONE) {
    return layout;
  }

  return <RelatedSpacesOrdersModalsProvider>{layout}</RelatedSpacesOrdersModalsProvider>;
}

/** 主内容区 + 全站底栏，保证各页在视口内主区可伸展、底栏贴底 */
export function AppLayout() {
  useEffect(() => {
    void globalModel.init();
  }, []);

  return (
    <PageLayoutProvider>
      <AppLayoutBody />
    </PageLayoutProvider>
  );
}
